const isBrowser = () => typeof window !== 'undefined';

let tracking = [];
if (isBrowser()) {
  window._hsq = window._hsq || [];
  tracking = window._hsq;
}

export const _hsq = tracking;
